import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, arg: string) : string {

    if (!value) {
      return value;
    }

    let limit = arg ? parseInt(arg, 10) : 10;
    let trail = arg.length > 1 ? arg[1] : '...';

    return value.length > limit ? value.substring(0, limit) + trail : value;
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/utils/pipes/truncate.ts